import { firestore } from "@/plugins/firebase"
import {
    collection,
    query,
    onSnapshot,
} from "firebase/firestore"


export default {
    state: {
        allCompaniesArray: [],
    },
    mutations: {},
    actions: {
        async getAllCompanies({ state }) {
            const datapath = "/Firmen"
            const vOrderRef = collection(firestore, datapath)
            const vOrderq = query(vOrderRef)

            onSnapshot(vOrderq, (querySnapshot) => {
                state.allCompaniesArray = [];
                querySnapshot.forEach((doc) => {
                    const docdata = { ...{ id: doc.id }, ...doc.data() }

                    state.allCompaniesArray.push(docdata)
                })
            })
        },
    },

}

